import React from "react";
import {
  Button,
  Modal,
  Form,
  Input
} from "antd"; // Import Table from antd
import CreatableSelect from "react-select/creatable";
import { Control, Controller, FieldErrors, SubmitHandler, UseFormHandleSubmit } from "react-hook-form";
// utils
import {
  CannyIForm,
  StringSelectObject,
} from "utils/interfaces";
// components

interface AddCannyModalProps {
    showAddModal: boolean,
    toggleAddModal: () => void,
    loadingButtons: boolean,
    handleSubmit: UseFormHandleSubmit<CannyIForm, CannyIForm>,
    errors: FieldErrors<CannyIForm>,
    onSubmit: SubmitHandler<CannyIForm>
    control: Control<CannyIForm, any, CannyIForm>,
    isValid: boolean,
    hardwareVersions: StringSelectObject[]
}

const AddCannyModal: React.FC<AddCannyModalProps> = ({
    showAddModal,
    toggleAddModal,
    loadingButtons,
    handleSubmit,
    errors,
    onSubmit,
    control,
    isValid,
    hardwareVersions
}) => {
  return (
    <Modal
      title='New Canny Device Batch'
      open={showAddModal}
      onCancel={toggleAddModal}
      closable={!loadingButtons}
      mask={{ closable: !loadingButtons }}
      footer={[
        <Button onClick={toggleAddModal} disabled={loadingButtons}>Close</Button>,
        <Button
        onClick={handleSubmit(onSubmit)}
        loading={loadingButtons}
        type="primary"
        disabled={!isValid || loadingButtons}
        >Save Changes</Button>
      ]}
    >
      <Form layout="vertical" preserve={false}>
        <Form.Item
          label='Number of items in batch'
          validateStatus={errors.items_in_batch ? "error" : ""}
          help={errors.items_in_batch?.message}
        >
          <Controller
            name="items_in_batch"
            control={control}
            rules={{
              required: 'This field is required',
              validate:{
                maxValue: (value:any) => value < 2000 ? true: 'Batch number cannot exced 2000'
              }
            }}
            render={({ field }) => (
              <Input
                {...field}
                type="number"
                value={field.value !== null ? field.value : ''}
                onChange={(e) => field.onChange(e.target.value === '' ? '' : parseInt(e.target.value, 10))}
              />
            )}
          />
        </Form.Item>
        <Form.Item
        label='Hardware version'
        validateStatus={errors.hardware_version ? "error" : ""}
        help={errors.hardware_version?.message}
        >
          <Controller
            name="hardware_version"
            control={control}
            rules={{ required: 'This field is required' }}
            render={({ field }) => (
              <CreatableSelect
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPosition="fixed"
                menuPlacement="bottom"
                isClearable
                placeholder="Select an existing version or type a new one"
                formatCreateLabel={(inputValue) => `Use "${inputValue}"`}
                options={hardwareVersions}
                value={hardwareVersions.find((hw) => hw.value === field.value) || (field.value ? { value: field.value, label: field.value } : null)}
                onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.value : null)}
              />
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCannyModal;
